import { makeStyles } from '@material-ui/core';
import React, { forwardRef } from 'react';
import { Dropdown } from 'react-bootstrap';
import theme from 'style/theme';
import styled from 'styled-components';

export interface DropdownOption {
  label: string;
  value: string;
}

export interface DropdownOptionNullable {
  label: string;
  value: string | null;
}

const Button = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  background: #5cabdd;
  border-radius: 8px;
  flex: none;
  order: 0;
  flex-grow: 0;
  border: none;
  color: #ffffff;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  height: 40px;

  :disabled {
    opacity: 1;
    background-color: #757677 !important;
  }
`;

type ToggleProps = {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  label?: string;
};

const CustomToggle = forwardRef<HTMLButtonElement, ToggleProps>(({ onClick, label }, ref) => (
  <Button
    id="customDropdownButton"
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    <span>{label}</span>
  </Button>
));

type Props = {
  options?: DropdownOption[];
  onSelect: (value: string | null) => void;
  buttonText?: string;
};

const useStyles = makeStyles(() => ({
  dropdownItem: {
    '&.active, &:active': {
      backgroundColor: theme.colors.malibu + ' !important',
    },
  },
}));

const CustomDropdown = ({ options, onSelect, buttonText }: Props) => {
  const classes = useStyles();
  const onSelectChange = (value: string | null) => {
    if (!value) return;
    onSelect(value);
  };
  return (
    <Dropdown onSelect={onSelectChange}>
      <Dropdown.Toggle as={CustomToggle} label={buttonText}>
        Custom toggle
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {options?.map((option) => (
          <Dropdown.Item
            eventKey={option.value}
            key={option.value}
            active={false}
            className={classes.dropdownItem}
          >
            {option.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CustomDropdown;
